<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header v-if="!loading" :headerName="'Problemas de UPD'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loading"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Data Inicial</label>
                      <datepicker v-model="dataSearch.dtInit" :language="ptBR" :format="customFormatter"
                                  placeholder="Data" required/>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Data Final</label>
                      <datepicker v-model="dataSearch.dtEnd" :language="ptBR" :format="customFormatter"
                                  placeholder="Data" required/>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>UserId</label>
                      <input v-model="dataSearch.userId" type="text" class="form-control" name="userId"
                             placeholder="UserID" required>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>CompanyId</label>
                      <input v-model="dataSearch.companyId" type="text" class="form-control" name="companyId"
                             placeholder="CompanyId" required>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label for="email">Email</label>
                      <input v-model="dataSearch.email" type="text" class="form-control" id="email" name="email">
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="getReportUpd()">Pesquisar</button>
                </div>
              </div>
            </div>

            <!-- No Result -->
            <div v-if="!loading && (dataUpd !== '' && !dataUpd.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Sem resultado na pesquisa.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loading && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loading && dataUpd.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total de usuário ({{ dataUpd.length }})</span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> IdUsuario</th>
                        <th> NOME</th>
                        <th> Total UPD Necessario</th>
                        <th> Total UPD Encontrado</th>
                        <th> Total UPD Faltando</th>
                        <th> Total UPD Repetido</th>
                        <th> Total UPD N ATT</th>
                        <th> Primeiro UPD</th>
                        <th> Ultimo UPD</th>
                        <th> DIAS FALTANTES</th>
                        <th> SITUAÇÂO</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="a in dataUpd">
                        <td>{{ a.userId }}</td>
                        <td>{{ a.userName }}</td>
                        <td>{{ a.totalUpdNecessary }}</td>
                        <td>{{ a.totalUpdCaught }}</td>
                        <td>{{ a.totalUpdMissing }}</td>
                        <td>{{ a.totalRepeated }}</td>
                        <td>{{ a.totalUpdNotSync }}</td>
                        <td>{{ a.firstUpd }}</td>
                        <td>{{ a.lastUpd }}</td>
                        <td>{{ a.daysMissing }}</td>
                        <td>{{ a.status }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>

  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from 'vuejs-datepicker';
import swal from 'sweetalert';
import moment from 'moment'

import {
  REPORT_UPD
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";

export default {
  name: "upd-issues",
  components: {
    datepicker,
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      ptBR: ptBR,
      loading: false,
      failRequest: false,
      dataUpd: '',
      dataSearch: {
        userId: '',
        companyId: '',
        dtInit: '',
        dtEnd: '',
        email: ''
      },
    }
  },
  methods: {
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    getReportUpd() {
      this.loading = true;
      this.failRequest = false;
      let url = REPORT_UPD;
      // 91684062F204A17A2C20D40B88E101B
      url += "?dtInit=" + moment(this.dataSearch.dtInit).format("YYYY-MM-DD");
      url += "&dtEnd=" + moment(this.dataSearch.dtEnd).format("YYYY-MM-DD");

      if (this.dataSearch.companyId)
        url += "&companyId=" + this.dataSearch.companyId;

      if (this.dataSearch.userId)
        url += "&userId=" + this.dataSearch.userId;

      if (this.dataSearch.email)
        url += "&email=" + this.dataSearch.email;

      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT REPORT_UPD:", response.data);

        this.dataUpd = response.data;
        this.loading = false;
        this.loading = false;
      }).catch((reason) => {
        this.loading = false;
        this.loading = false;
        this.failRequest = true;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
  },
  beforeMount() {
    this.dataSearch.dtInit = new Date(moment().subtract(5, 'days'));
    this.dataSearch.dtEnd = new Date(moment().subtract(1, 'days'));
  }
}
</script>

<style lang="scss">
.vdp-datepicker {
  display: inline-block;
  width: 90%;

  input {
    border: 1px solid #ccc;
    border-radius: 5px;
    height: 34px;
    width: 100%;
    padding: 0 10px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/reports/UPDIssues.vue